<template>
    <div class="ArtSlider">
        <template>
            <div>
                <v-carousel
                        cycle
                        height="auto"
                        show-arrows
                        show-arrows-on-hover
                        class="hidden-md-and-down"
                >
                    <v-carousel-item
                            v-for="(item,i) in items"
                            :key="i"
                            reverse-transition="fade-transition"
                            transition="face-transition">
                        <v-img :src="item.src" aspect-ratio="1.77" style="max-width: 100%"></v-img>
                    </v-carousel-item>
                </v-carousel>
            </div>
        </template>

    </div>
</template>


<script>

    export default {
        name: 'ArtSlider',
        data: function () {
            return {
                alignment: 'center',
                dense: false,
                justify: 'center',
                items: [
                    {
                        src: require('../assets/site-images/1977-850x510-the-touch.jpg')
                    },
                    {
                        src: require('../assets/site-images/1978-850x510-the-piano-player.jpg')
                    },
                    {
                        src: require('../assets/site-images/1979-850x510-stonehenge.jpg')
                    },
                    {
                        src: require('../assets/site-images/1981-850x510-dreadnaught-arizona.jpg')
                    }
                ]
            }
        },

        methods: {},

        computed: {}
    }

</script>

<style scoped>
    img {
        height: auto;
        max-width: 100%;
    }

    .div .VueCarousel-pagination {
        background-color: black;
    }

    .VueCarousel-pagination {
        background-color: black;
    }
</style>
